<template>
  <div class="app-wrapper">
    <!-- 头部 -->
    <div
      class="e6-header-section leftMenu"
      :class="{ 'is-scroll': urlPath }"
      v-show="!isFullScreen"
    >
      <BaseHeader :collapse.sync="isCollapse" />
    </div>
    <!-- 头部 end -->
    <section
      class="e6-container-section"
      :class="{ 'is-collapse': isCollapse }"
    >
      <div
        class="e6-menu-section left"
        v-show="!isFullScreen"
        :class="[
          { full: isFullScreen },
          { 'is-scroll': urlPath && !isFullScreen }
        ]"
      >
        <base-menu mode="vertical" :collapse="isCollapse" />
      </div>
      <main
        class="e6-main-section leftMenu"
        :class="[
          { full: isFullScreen },
          { 'is-scroll': urlPath && !isFullScreen }
        ]"
      >
        <transition name="fade-transform" mode="out-in">
          <router-view />
        </transition>
      </main>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import baseMenu from "../components/menu";
import BaseHeader from "./components/baseHeader";
// import individuationConfig from "@/individuation.config";

export default {
  components: {
    baseMenu,
    BaseHeader
  },
  created() {
    this.isCollapse = this.$GLOBAL_CONFIG.menuIsCollapse;
  },
  data() {
    return {
      isCollapse: false
    };
  },
  computed: {
    ...mapGetters(["isFullScreen"]),
    urlPath() {
      if (this.$route.path === "/home") {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss">
@import "_private/assets/styles/common/var.scss";

$--header-height: 50px !default;
.app-wrapper {
  height: 100vh;
  .e6-header-section {
    height: $--header-height;
    .header__user-setting {
      color: #a6a9ae;
    }
  }
  .e6-container-section {
    position: relative;
    height: calc(100vh - #{$--header-height});
    &.is-scroll {
      top: 60px;
      width: 1920px;
      min-height: 860px;
      overflow: auto;
    }
    &.full {
      height: 100vh;
      width: 100vw;
    }
    .e6-menu-section {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: $--menu-width;
      transition: width 0.5s ease;
      overflow: hidden;
      /deep/ .e6-nav-menu__scroll {
        height: 100%;
      }
      .el-menu {
        background-color: transparent !important;
        .el-menu-item {
          &.is-active {
            color: #fff !important;
            background-color: #14a2ea !important;
            i {
              color: #fff !important;
            }
          }
        }
        .el-submenu__title,
        .el-menu-item,
        .el-submenu {
          background-color: transparent !important;
          color: #90acf8 !important;
          i {
            color: #90acf8 !important;
          }
          &.is-active {
            .el-submenu__title {
              color: #fff !important;
              i {
                color: #fff !important;
              }
            }
          }
        }

        .el-submenu {
          .el-menu {
            .el-submenu__title,
            .el-menu-item,
            .el-submenu {
              background-color: transparent !important;
              color: #fff !important;
              i {
                color: #fff !important;
              }
              &.is-active {
                background-color: #14a2ea !important;
              }
              &:hover {
                background-color: #14a2ea !important;
              }
            }
          }
        }
      }
    }

    .e6-main-section {
      position: absolute;
      top: 0;
      bottom: 0;
      left: $--menu-width;
      right: 0;
      transition: left 0.5s ease;
      overflow: hidden;
      &.full {
        left: 0;
        height: 100vh;
        width: 100vw;
      }
    }
    .e6-main-section.leftMenu {
      background-color: #eff0f9 !important;
      .e6-form-extend-wrapper {
        border-radius: 5px;
      }
    }
    &.is-collapse {
      .e6-menu-section {
        width: $--menu-width--collapse;
        /deep/ .el-scrollbar__view {
          width: $--menu-width--collapse;
        }
      }
      .e6-main-section {
        left: $--menu-width--collapse;
        &.full {
          left: 0;
        }
      }
    }
  }
  .g-nav-menu__scroll {
    height: 100%;
    width: 100%;
  }
  // .e6-main-section {
  /deep/ .el-scrollbar__wrap {
    overflow-y: auto;
    overflow-x: hidden;
  }
  /deep/ .el-scrollbar__view {
    width: $--menu-width;
    .el-menu {
      border: 0;
    }
  }
  // }
}
</style>
